export default __webpack_public_path__ + "static/media/google.38c960eb.svg";